const githubLink = "https://github.com/emmanuelronoh";
const instaLink = "https://instagram.com/eronoh036/";
const linkedInLink = "https://www.linkedin.com/in/emmanuel-kipkirui-9a4b8831a";
const twitterLink = "https://twitter.com/eronoh036";
const emailLink = "mailto:eronoh036@gmail.com";
const facebookLink = "https://www.facebook.com/emmanuel.kipkirui"; 

const profileLinks = {
    githubLink,
    instaLink,
    linkedInLink,
    twitterLink,
    emailLink,
    facebookLink
};

const SocialData = profileLinks;
export default SocialData;
